import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import AutoBindComponent from "../../common/AutoBindComponent";

import Fieldset from "../../common/Fieldset";
import Form from "../../common/Form";
import Row from "../../common/Row";
import Section from "../../common/Section";
import { bindActionCreators } from "redux";
import * as types from "../../../constants/ComponentConstants";
import classnames from "classnames";
import * as layoutActions from "../../../actions/voortgangsrapportLayoutActions";
import redirector from "../../../util/redirector.js";

class VRIndienenBevestigingPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
		};
	}

	componentWillMount() {
		const ingediend = this.props.indienen;
		this.props.loadLayout(ingediend.voortgangsrapportId);
	}

	gaVerder(dossierId) {
		return function () {
			redirector.goTo('/mijndossier/' + dossierId);
		};
	}

	render() {
		return (
			<Section title="Dien in" color={types.COLOR_GREEN}>
				<Form title="Bevestigingsformulier" name="Bevestigingsformulier"rightButtonLabel="Ga verder"
					onRightButtonClick={this.gaVerder(this.props.indienen.origineelDossierId)} isNotRequired>
					<Fieldset>
						<Row>
							<p>Het rapport is verwerkt.<br />
							Je kunt geen wijzigingen meer aanbrengen.</p>							
							<br />
						</Row>
					</Fieldset>
				</Form>
			</Section >
		);
	}
}

// ----------------------------------------------------------------------------

VRIndienenBevestigingPage.propTypes = {
	loadLayout: PropTypes.func
};


function mapStateToProps(state, ownProps) {
	return {
		indienen: state.indienen
	};
}
function mapDispatchToProps(dispatch) {
	return {
		loadLayout: bindActionCreators(layoutActions.loadIndienenBevestigingPageLayout, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(VRIndienenBevestigingPage);